export default "__VITE_PUBLIC_ASSET__1b057b96__"